import { render, staticRenderFns } from "./GlobalSettings.vue?vue&type=template&id=f4c99e80&scoped=true"
import script from "./GlobalSettings.vue?vue&type=script&lang=js"
export * from "./GlobalSettings.vue?vue&type=script&lang=js"
import style0 from "./GlobalSettings.vue?vue&type=style&index=0&id=f4c99e80&prod&lang=scss&scoped=true"
import style1 from "./GlobalSettings.vue?vue&type=style&index=1&id=f4c99e80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c99e80",
  null
  
)

export default component.exports